import React from "react";

function Loading(props) {
  const winColor = props.color[props.color[4]];
  return (
    <>
      <div
        className="guess-color"
        style={{
          "background-color": `rgb(${winColor[0]},${winColor[1]},${winColor[2]})`
        }}
      >
        <h1 className="question-number">{props.questionNumber}</h1>
      </div>
    </>
  );
}
export default Loading;
